/**
 * defa.views.UnitSearchRegistrationForm
 * A view to search for unit by registration number.
 * @version 1.0.1
 */
import Form from 'scripts/poppet/form';
import template from 'templates/unitSearchRegistrationForm.jst.html'

const selectors = {
	buttonSerial     : '[data-click=search-serial]',
	inputRegistration: '[data-input=registration-number]',
};

const UnitSearchRegistrationForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		reg   : selectors.inputRegistration,
		serial: selectors.buttonSerial,
	},
	
	events: {
		'click @ui.serial': 'onClickSerial',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onClickSerial: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'unit:search:serial' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	submit: function () {
		
		this.model.fetchByRegistration( {
			registrationNumber: this.ui.reg.val().trim().replace( /-|\s/g, '' ),
		} );
		
	},
	
} );

export default UnitSearchRegistrationForm;